export default "/assets/images/exploding-head.3e93b5509e56ba95.png";